import CalendarRoom from './CalendarRoom';

export default CalendarRoom;
